<template>
  <div>
    <v-card class="sr-treeview">
      <v-card-text>
        <v-treeview
          :items="documentations"
          activatable
          item-children="children"
          item-key="path"
          item-text="name"
          @update:active="select"
        ></v-treeview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Treeview",
  props: {
    value: { type: [String, Number] },
  },
  data: () => ({
    selected: null,
    documentations: [],
  }),
  mounted() {
    this.fetchDocumentations()
  },
  methods: {
    fetchDocumentations() {
      this.$axios.get("office/common/documentations").then(response => {
        this.documentations = response.data.data
      })
    },
    select(e) {
      this.selected = e.pop()
      this.$emit("input", this.selected)
    },
  },
}
</script>
